export const COMBO_CHART_ERROR_MESSAGES = {
  SECONDARY_MEASURE_REQUIRED: 'Secondary measure is required for combo chart',
  SECONDARY_MEASURE_MISSING:
    'Please select a secondary measure for combo chart',
  INVALID_METRIC_COMBINATION:
    'Cannot use the same metric with same calculation for both measures',
} as const;

export const CHART_ERROR_MESSAGES = {
  COMBO_CHART: COMBO_CHART_ERROR_MESSAGES,
  VALIDATION_FAILED: 'Chart validation failed',
  FIELD_REQUIRED: 'Field selection is required',
  CROSS_FIELD_REQUIRED: 'Cross field selection is required',
  CANDIDATES_REQUIRED: 'At least one candidate must be selected',
} as const;

export type ComboChartErrorType = keyof typeof COMBO_CHART_ERROR_MESSAGES;
export type ChartErrorType = keyof typeof CHART_ERROR_MESSAGES;
